import { apiFetch, apiFetchLong } from './api';

/** Documents à apporter (Paramétrage), tous ou ceux d'une formation. */
export function getFormationDocuments(params = {}) {
  const query = new URLSearchParams(
    Object.entries(params).filter(([, value]) => value !== undefined && value !== '')
  ).toString();
  return apiFetch(`/formation-documents${query ? `?${query}` : ''}`);
}

export function createFormationDocument(data) {
  return apiFetch('/formation-documents', { method: 'POST', body: JSON.stringify(data) });
}

export function updateFormationDocument(id, data) {
  return apiFetch(`/formation-documents/${id}`, { method: 'PUT', body: JSON.stringify(data) });
}

export function deleteFormationDocument(id) {
  return apiFetch(`/formation-documents/${id}`, { method: 'DELETE' });
}

/** Import par copier-coller : l'IA propose des documents, rien n'est écrit. */
export function analyserImportDocuments(texte) {
  return apiFetchLong('/formation-documents/import/analyser', {
    method: 'POST',
    body: JSON.stringify({ texte }),
  });
}

/** Enregistre les documents retenus après relecture (création ou mise à jour). */
export function enregistrerImportDocuments(documents) {
  return apiFetch('/formation-documents/import/enregistrer', {
    method: 'POST',
    body: JSON.stringify({ documents }),
  });
}
